var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"app-footer"},[_c('span',[_c('a',{attrs:{"href":"https://leaf.ai"}},[_vm._v("leaf analytics, llc")]),_vm._v(" © "+_vm._s(_vm.year))])])
}
var staticRenderFns = []

export { render, staticRenderFns }